import { useQuery } from 'react-query';

import { type QueryFunction, useRequest } from '@frontend/api';

export type UseGetCustomTableRowsParams = {
  supplierId: string;
  rowNumbers: number[];
  tableName: string;
  searchAllRows: boolean;
};

export type UseGetCustomTableRowsData = {
  columns: string[];
  rows: { key: string; value: any }[];
};

export type UseGetCustomTableRowsRequestQuery = {
  search: string;
};

export type UseGetCustomTableRowsQueryKey = [
  'suppliers',
  'customTableRows',
  UseGetCustomTableRowsParams,
  UseGetCustomTableRowsRequestQuery,
];

export const getCustomTableRowsQueryKey = (
  params: UseGetCustomTableRowsParams,
  query: UseGetCustomTableRowsRequestQuery,
): UseGetCustomTableRowsQueryKey => [
  'suppliers',
  'customTableRows',
  params,
  query,
];

export const useGetCustomTableRows: QueryFunction<
  UseGetCustomTableRowsData,
  [UseGetCustomTableRowsParams],
  UseGetCustomTableRowsQueryKey,
  UseGetCustomTableRowsRequestQuery
> = (params, { requestOptions, queryOptions, query } = {}) => {
  const queryKey = getCustomTableRowsQueryKey(params, query);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.supplierId}/custom_table_rows`, {
        query,
        init: {
          method: 'POST',
          signal,
          body: params,
        },
      }),
  });
};
